import React, { useState } from 'react';
import axios from '../../plugins/axios';
import { useParams, useNavigate } from 'react-router-dom';
import checkCrmSidebarNotifications from '../../api/notifications/checkCrmSidebarNotifications';
import getDealCard from '../../api/deals/getDealCard';
import { useOutletContext } from 'react-router-dom';

// components
import Form from '../../components/Form/Form';
import Button from '../../components/Button/Button';
import SelectClients from '../../components/Selects/SelectClients';
import SelectStatuses from '../../components/Selects/SelectStatuses';
import SelectPaymentTypes from '../../components/Selects/SelectPaymentTypes';
import SelectDealPaymentStatuses from '../../components/Selects/selectDealPaymentStatuses';
import Datepicker from '../../components/Inputs/Datepicker/Datepicker';
import HookForm from '../../components/HookForm/HookForm';
import Loader from '../../components/Loader/Loader';
import Alert from '../../components/Alert/Alert';
import HookModalForm from '../../components/HookModalForm/HookModalForm';
import SelectEquipments from '../../components/Selects/SelectEquipments';
import SelectAdditionalServices from '../../components/Selects/SelectAdditionalServices';
import SelectCreditPeriod from '../../components/Selects/SelectCreditPeriod';

// icons
import edit from '../../brand/generated/editForm.svg';
import SelectAdditionalServicesModal from '../../components/Modals/SelectAdditionalServicesModal';
import addAdditionalServicesToDeal from '../../api/deals/addAdditionalServicesToDeal';
import SelectDealStatuses from '../../components/Selects/SelectDealStatuses';
import alert from '../../helpers/alert';
import SelectManagers from '../../components/Selects/SelectManagers';
import editDeal from '../../api/deals/editDeal';
import createNumberMask from '../../utils/createNumberMask';
import numberMask from '../../utils/numberMask';
import { DEAL_STEPS } from '../../constants';
import setStep from '../../api/deals/setStep';

const formStyles = {
  dealInfo: { display: 'grid', gap: '20px', gridTemplateAreas: `'a a b b' 'c c c c'` },
  creditInfo: { display: 'grid', gap: '20px', gridTemplateColumns: 'auto auto auto auto' },
  other: { display: 'grid', gap: '20px' },
};

const DealMainInfo = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [equipmentsCount, updateCounters] = useOutletContext();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [error, setError] = React.useState({});
  const [succes, setSucces] = React.useState({});
  const [other, setOther] = React.useState([
    {
      type: 'select',
      label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
      component: SelectManagers,
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      name: 'manager',
    },
    { type: 'input', label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ', placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹', name: 'comment' },
  ]);
  const [dealInfo, setDealInfo] = React.useState([]);
  const [equipmentForm, setEquipmentForm] = useState([
    {
      name: 'services',
      component: SelectAdditionalServices,
      label: 'Ð£ÑÐ»ÑÐ³Ð¸',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      isMulti: true,
      isSearchable: true,
    },
    {
      name: 'equipments',
      component: SelectEquipments,
      label: 'ÐÐ±Ð¾ÑÑÐ´Ð¾Ð²Ð°Ð½Ð¸Ðµ',
      placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
      isMulti: true,
      isSearchable: true,
    },
  ]);

  const [dealId, setDealId] = React.useState(null);

  const getDeal = async () => {
    await getDealCard({ id: id })
      .then((res) => {
        setDealId(res.data.id);
        const dealInfo = [
          {
            name: 'createdAt',
            type: 'date',
            defaultValue: new Date(res.data.createdAt),
            label: 'ÐÐ°ÑÐ°',
            component: Datepicker,
          },
          {
            type: 'input',
            name: 'dealId',
            label: 'ID',
            placeholder: '_ _ _ _ _ _ _ _',

            defaultValue: res.data.id,
          },
          {
            component: SelectClients,
            name: 'clientId',
            label: 'ÐÐ»Ð¸ÐµÐ½Ñ',
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            isSearchable: true,
            style: { gridArea: 'c' },
            defaultValue: {
              id: res.data?.client?.id,
              label: res.data?.client ? `${res.data?.client?.name} ${res.data?.client?.surname}` : null,
            },
          },
          {
            label: 'Ð¡ÑÐ°ÑÑÑ ÑÐ´ÐµÐ»ÐºÐ¸',
            name: 'statusId',
            component: SelectDealStatuses,
            defaultValue: {
              value: res?.data?.status?.id,
              label: res?.data?.status?.title,
              paymentTypeId: res.data.paymentType.id,
            },
          },
          {
            label: 'Ð¡Ð¿Ð¾ÑÐ¾Ð± Ð¾Ð¿Ð»Ð°ÑÑ',
            name: 'paymentTypeId',
            component: SelectPaymentTypes,
            defaultValue: { value: res.data.paymentType?.id, label: res.data.paymentType?.title },
          },
          {
            label: 'Ð¡ÑÐ°ÑÑÑ Ð¾Ð¿Ð»Ð°ÑÑ',
            name: 'statusPaymentId',
            component: SelectDealPaymentStatuses,
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            defaultValue: { value: res.data.statusPayment?.id, label: res.data.statusPayment?.title },
          },
          {
            name: 'sum',
            label: 'Ð¡ÑÐ¼Ð¼Ð° ÑÐ´ÐµÐ»ÐºÐ¸',
            placeholder: 'ÐÐ²ÑÐ¾Ð¼Ð°ÑÐ¸ÑÐµÑÐºÐ¸Ð¹ ÑÐ°ÑÑÐµÑ',
            // ÐµÑÐ»Ð¸ Ð¿Ð¾ ÑÐ´ÐµÐ»ÐºÐµ ÑÐ¶Ðµ Ð¿Ð¾Ð´Ð°Ð²Ð°Ð»Ð°ÑÑ Ð·Ð°ÑÐ²ÐºÐ° Ð² Ð±Ð°Ð½Ðº â Ð¿Ð¾ÐºÐ°Ð·ÑÐ²Ð°ÐµÐ¼ ÑÐµÐ½Ñ Ð¸Ð· Ð½ÐµÑ
            // (Ð·Ð°Ð¼Ð¾ÑÐ¾Ð¶ÐµÐ½Ð½ÑÑ Ð½Ð° Ð¼Ð¾Ð¼ÐµÐ½Ñ Ð¿Ð¾Ð´Ð°ÑÐ¸), Ð° Ð½Ðµ ÑÐµÐºÑÑÐ¸Ð¹ Ð¿ÐµÑÐµÑÑÑÑ Ð¿Ð¾ ÑÐ¾ÑÑÐ°Ð²Ñ Ð·Ð°ÐºÐ°Ð·Ð°,
            // ÐºÐ¾ÑÐ¾ÑÑÐ¹ Ð¼Ð¾Ð¶ÐµÑ Ð¸Ð·Ð¼ÐµÐ½Ð¸ÑÑÑÑ Ð¿Ð¾ÑÐ»Ðµ Ð¿Ð¾Ð´Ð°ÑÐ¸ Ð·Ð°ÑÐ²ÐºÐ¸
            defaultValue: res.data.creditAppeal?.fullPrice ?? res.data.sum,
            mask: numberMask,
          },
          {
            label: 'ÐÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ',
            name: 'initialFee',
            dependency: 'paymentTypeId',
            dependencyAccessor: (obj) => obj?.value,
            placeholder: 'ÐÐ²ÐµÐ´Ð¸ÑÐµ Ð¿ÐµÑÐ²Ð¾Ð½Ð°ÑÐ°Ð»ÑÐ½ÑÐ¹ Ð²Ð·Ð½Ð¾Ñ',
            isCredit: true,
            mask: numberMask,
          },
          {
            label: 'Ð¡ÑÐ¾Ðº ÐºÑÐµÐ´Ð¸ÑÐ¾Ð²Ð°Ð½Ð¸Ñ, Ð¼ÐµÑÑÑÐµÐ²',
            name: 'period',
            component: SelectCreditPeriod,
            dependency: 'paymentTypeId',
            dependencyAccessor: (obj) => obj?.value,
          },
          {
            label: 'ÐÑÐ¸ÑÐ¸Ð½Ð°',
            name: 'cancelDescription',
            defaultValue: res.data.cancelDescription,
            disabled: true
          },
        ];
        setDealInfo(dealInfo);

        setOther([
          {
            type: 'select',
            label: 'ÐÑÐ²ÐµÑÑÑÐ²ÐµÐ½Ð½ÑÐ¹ Ð¼ÐµÐ½ÐµÐ´Ð¶ÐµÑ',
            component: SelectManagers,
            placeholder: 'ÐÑÐ±ÐµÑÐ¸ÑÐµ Ð¸Ð· ÑÐ¿Ð¸ÑÐºÐ°',
            name: 'manager',
            defaultValue: res.data.manager
              ? { value: res.data.manager?.id, label: res.data.manager?.name + ' ' + res.data.manager?.surname }
              : null,
          },
          {
            type: 'input',
            label: 'ÐÐ°Ð¼ÐµÑÐºÐ¸/ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¸ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ',
            placeholder: 'ÐÑÑÐ°Ð²ÑÑÐµ Ð²Ð°Ñ ÐºÐ¾Ð¼Ð¼ÐµÐ½ÑÐ°ÑÐ¸Ð¹',
            name: 'comment',
          },
        ]);

        if (res.data.notifications.length > 0) {
          let ids = res.data.notifications.map((item) => {
            return item.id;
          });
          checkCrmSidebarNotifications({ notificationIds: ids })
            .then((res) => {
              window.dispatchEvent(new Event('crmSidebarRefresh'));
            })
            .catch((error) => {});
        }
      })
      .catch((error) => {
        console.log(error, '[error]');
      })
      .finally(() => setLoading(false));
  };
  const [rerender, setRerender] = React.useState(false);

  const handleSubmit = (data) => {
    setSubmitLoading(true);
    const initialFee = dealInfo[7]?.value;
    const creditPeriod = dealInfo[8]?.value?.value;
    const payload = new Map(Object.entries(data));
    payload.delete('dealId');
    payload.set('id', parseInt(dealInfo[1].defaultValue));
    payload.set('clientId', data?.clientId?.value ?? dealInfo[2].defaultValue.id);
    payload.set('statusId', data?.statusId?.value ?? dealInfo[3].defaultValue.value);
    payload.set('paymentTypeId', data?.paymentTypeId?.value ?? dealInfo[4].defaultValue.value);
    payload.set('statusPaymentId', data?.statusPaymentId?.value ?? dealInfo[5].defaultValue.value);
    payload.set('sum', dealInfo[6].defaultValue);

    axios
      .post('/api/crm/deals/editDeal', Object.fromEntries(payload))
      .then((res) => {
        // if (data.initialFee) {
        //   axios.post('/api/crm/creditPlatform/createCreditAppeal', {
        //     initialFee: parseInt(data.initialFee),
        //     period: parseInt(data.period.value),
        //     dealId: parseInt(dealInfo[1].defaultValue),
        //   });
        // }
        setSucces({ message: 'Ð¡Ð´ÐµÐ»ÐºÐ° ÐÐ±Ð½Ð¾Ð²Ð»ÐµÐ½Ð°' });
        setTimeout(() => {
          navigate('/deals');
        }, 1000);
      })
      .catch((error) => alert.error(error.response.data.errorMessage ?? JSON.stringify(error.response)))
      .finally(() => setSubmitLoading(false));
  };

  const addDealComment = (values) => {
    setLoading(true);
    editDeal({
      id: dealId,
      dealId,
      managerId: values?.manager?.value,
      comment: values?.comment,
    }).then(() => {
      alert?.success('Ð¡Ð´ÐµÐ»ÐºÐ° ÑÑÐ¿ÐµÑÐ½Ð¾ Ð¾Ð±Ð½Ð¾Ð²Ð»ÐµÐ½Ð°');
      getDeal();
    }).catch(() => {
      setLoading(false);
    })
  };

  React.useEffect(() => {
    getDeal();
    updateCounters();
  }, []);

  const handleAddEquipments = (data) => {
    console.log(data);
  };

  const handleAddAdditionalServicesSubmit = (orderId, services) => {
    console.log(orderId, services);
    addAdditionalServicesToDeal(orderId, services)
      .then(() => {
        setShowModal(false);
        updateCounters();
      })
      .catch((err) => alert(err));
  };

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          {submitLoading && <Loader />}
          <div style={{ paddingBottom: '20px' }}>
            <div style={{ opacity: 100 }}>{rerender}</div>
            <HookForm
              inputs={dealInfo}
              title={'ÐÐ½ÑÐ¾ÑÐ¼Ð°ÑÐ¸Ñ Ð¾ ÑÐ´ÐµÐ»ÐºÐµ'}
              grid={formStyles.dealInfo}
              onSubmit={handleSubmit}
              action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ Ð¸ Ð¿ÑÐ¾Ð´Ð¾Ð»Ð¶Ð¸ÑÑ'}
              border
              isAddEquipments={equipmentsCount.equipments || equipmentsCount.services ? false : true}
              handleAddEquipments={() => setShowModal(true)}
              responsiveForm
            />
            {dealId && (
              <HookForm
                inputs={other}
                title={'ÐÐ¾Ð¿Ð¾Ð»Ð½Ð¸ÑÐµÐ»ÑÐ½Ð¾'}
                grid={{ display: 'grid', gap: 20 }}
                onSubmit={addDealComment}
                action={'Ð¡Ð¾ÑÑÐ°Ð½Ð¸ÑÑ '}
                responsiveForm
              />
            )}
            <SelectAdditionalServicesModal
              isOpen={showModal}
              onClose={() => setShowModal(false)}
              onSubmit={handleAddAdditionalServicesSubmit}
              dealId={dealId}
            />
            {/* {showModal && (
              <HookModalForm
                title={'ÐÐ¾Ð¿. ÑÑÐ»ÑÐ³Ð¸'}
                closeModal={() => setShowModal(false)}
                mainForm={equipmentForm}
                setMainForm={setEquipmentForm}
                grid={formStyles.other}
                action={'ÐÐ¾Ð±Ð°Ð²Ð¸ÑÑ'}
                handleSubmit={handleAddEquipments}
              />
            )} */}
          </div>
                </>
      )}
      {error.message && <Alert message={error.message} onClick={setError} />}
      {succes.message && <Alert message={succes.message} />}
    </>
  );
};

export default DealMainInfo;
